<template>
    <div id="main-wrapper" :dir="$i18n.locale == 'ar'? 'rtl':'ltr'">
        <NavbarDark/>

        <div class="page-title" :class="{ 'ltr': $i18n.locale === 'en', 'rtl': $i18n.locale === 'ar' }">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title">{{$t('About the website')}}</h2>
                    </div>
                </div>
            </div>
        </div>


        <section>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6">
                        <img :src="aboutImg" class="img-fluid" alt="about-image" />
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="story-wrap explore-content">
                            <h2>{{$t('From Ancient Trade Routes To Modern Business Hubs')}}</h2>
                            <p>{{$t('In Syria, the heart of ancient civilizations, caravans once roamed the Silk Roads, carrying goods and knowledge, connecting traders to markets, and laying the foundation for lasting commercial ties. Today, Ruqm revives this rich heritage—but with a modern touch, tailored for the digital age and smart connectivity.')}}</p>
                            <h2>{{$t('What is Ruqm?')}}</h2>
                            <p>{{$t('Ruqm is your smart platform for exploring trade exhibitions and business events across many Arab countries in particular and around the world in general. You can search for the latest exhibitions, connect with exhibitors, and plan your participation with ease.Inspired by the meaning of “Ruqm” – which refers to inscriptions and historical records that preserved knowledge and commercial agreements – our platform serves as a modern guide documenting the most important trade and networking opportunities in the world of exhibitions')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="sec-heading center">
                            <h2>{{$t('Why Ruqm?')}}</h2>
                        </div>
                    </div>
                </div>
                
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6">
                        <div v-for="(item, index) in currentWorkData" :key="index" class="icon-mi-left" >
                            <i :class="item.icon" class="px-2"></i>
                            <div class="icon-mi-left-content" style="margin-left:5%">
                                <h4>{{item.title}}</h4>
                                <p>{{item.desc}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <img :src="aboutImg2" class="img-fluid" alt="about-image-2" />
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6">
                        <img :src="Img" class="img-fluid" alt="image" />
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="story-wrap explore-content">
                            <h2>{{$t('Start Now with Ruqm and Unlock a World of Business Opportunities')}}</h2>
                            <p>{{$t('At Ruqm, we believe that opportunities don’t wait—they need to be seized. That’s why we provide a seamless and professional experience for entrepreneurs, investors, and business enthusiasts, keeping them at the heart of every event. From caravan trails to modern business platforms, the journey continues with Ruqm.')}}</p>                        
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>

</template>

<script setup>
import Img from '@/assets/img/about-us-10.webp'
import aboutImg from '@/assets/img/sb.webp'
import aboutImg2 from '@/assets/img/about-us-2.webp'
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import { computed } from 'vue';
import { workData } from '@/data/data';
import { workDataEn } from '@/data/data';
import { useI18n } from "vue-i18n"; 

import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
const route = useRoute()

const { locale } = useI18n();

const currentWorkData = computed(() => {
    return locale.value === 'ar' ? workData : workDataEn;
});
const baseUrl = 'https://ruqm.me'

const canonicalUrl = computed(() =>
  `${baseUrl}${route.path}`
)

const supportedLocales = ['en', 'ar']

const hreflangLinks = computed(() => {
  const pathWithoutLang = route.path.replace(/^\/(en|ar)/, '')

  return supportedLocales.map(lang => ({
    rel: 'alternate',
    hreflang: lang,
    href: `${baseUrl}/${lang}${pathWithoutLang}`
  }))
})
useHead(() => ({
  link: [
    { rel: 'canonical', href: canonicalUrl.value },
    ...hreflangLinks.value,
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en${route.path.replace(/^\/(en|ar)/, '')}`
    }
  ]
}))
</script>
